<template>
  <v-card>
    <v-card-title>
      <span class="headline" data-test="form-title">{{ formTitle }}</span>
    </v-card-title>

    <v-card-text>
      <v-form>
        <v-container>
          <v-row >
            <v-col cols="12">
              <v-text-field 
                ref="name-input"
                v-model="document.title" 
                label="Nom" 
                required
                :error-messages="titleErrors"
                @keyup.enter="save"
              ></v-text-field>
            </v-col>
            <v-col cols="12" v-if="document.id">
              <v-icon small class="mr-2">attachment</v-icon> <a :href="filePath">{{document.fileName}}</a>
            </v-col>
            <v-col v-else>
              <input id="file" type="file" @change="handleFile" ref="file">
              <p v-if="!$v.document.file.required && $v.document.title.$dirty" class="error--text">{{$t('Documents.Form.fileRequired')}}</p>
            </v-col>
            <v-col cols="12">
              <v-textarea 
                ref="description-textarea"
                v-model="document.description" 
                label="Description" 
                @keyup.enter="save"
              ></v-textarea>
            </v-col>
            <v-col cols="4">
              <v-checkbox label="Rendre publique" prepend-icon="lock_open" v-model="document.isPublic"></v-checkbox>
            </v-col>
            <v-col cols="12" v-show="!document.isPublic">
              <GroupSelector :groups.sync="document.groups" outline/>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn ref="cancel-btn" color="grey" text @click="cancel">{{$t('Global.Action.cancel')}}</v-btn>
      <v-btn ref="save-btn" color="primary" text :loading="loading" @click="save">{{$t('Global.Action.save')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import GroupSelector from '@/components/Utils/GroupSelector'
import { FileMixin } from '@/mixins/index'
export default {
  name: 'DocumentEditor',
  components: { GroupSelector },
  mixins: [FileMixin],
  props: {
    defaultDocument: {type: Object, required: false},
    defaultFormTitle: {type: String, required: false},
    loading: {type: Boolean, required: false}
  },
  data: () => ({
    document: null,
    fileListener: null,
    default: {
      title: '',
      file: null,
      description: '',
      isActive: false,
      isPublic: false,
      groups: [],
    }
  }),
  computed: {
    formTitle () {
      return this.defaultFormTitle || (this.document.id ? 'Modification' : 'Création')
    },
    titleErrors () {
      const errors = []
      if (!this.$v.document.title.$dirty) return errors
      !this.$v.document.title.required && errors.push('Nom requis')
      return errors
    },
    filePath () {
      return this.document.id && this.$_file_getDocumentPath(this.document.id)
    }
  },
  watch: {
    defaultDocument () {
      this.resetForm()
    }
  },
  validations: {
    document: {
      title: { required },
      file: { required: requiredIf((document) => !document.id) }
    }
  },
  methods: {
    handleFile () {
      this.document.file = this.$refs.file.files[0]
    },
    init () {
      this.document = this.defaultDocument ? {...this.defaultDocument} : {...this.default}
    },
    save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$emit('save', this.document)
      } else {
        this.$emit('invalid-form')
      }
    },
    cancel () {
      this.$emit('cancel')
      this.resetForm()
    },
    resetForm () {
      this.init()
      if (this.$refs.file) this.$refs.file.value = null
      this.$v.$reset()
    }
  },
  created () {
    this.init()
  }
}
</script>